import React from "react";
import NavigationBar from "../Components/GlobalComponents/Navbar";
import InteriorDesignNavigation from "../Components/InteriorDesignComponents/InteriorDesignNavigation";
import CommercialSelectionComponent from "../Components/CommercialComponents/CommercialSelectionComponent";

const InteriorDesignCommercial = () => {
  return (
    <div
      style={{
        backgroundColor: "#1A1A1A",
           height:"100vh"
      }}
    >
      <NavigationBar />
      <CommercialSelectionComponent />
    </div>
  );
};

export default InteriorDesignCommercial;
